var React = require('react');

function Travel (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M-13-10h56v56h-56z","opacity":".5","key":0}),React.createElement("path",{"stroke":"#006AFF","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","d":"M1.313 6.75h24.892L13.72 25.205 1.313 6.75zm12.4 18.5v10.852m-4.312 0h8.716M1.377 1.66l7.618 2.068 3.062 9.148m-6.257.292h15.825m5.288-2.604a4.062 4.062 0 1 0 0-8.125 4.062 4.062 0 0 0 0 8.124z","key":1})]));
}

Travel.defaultProps = {"width":"32","height":"38","viewBox":"0 0 32 38"};

module.exports = Travel;

Travel.default = Travel;
